import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getPlayIndex } from '@gameday/utils/selectors/getPlayIndex';
import { getTracking, getTrackingGameState, getCurrentViewState } from '@gameday/utils/selectors/getTracking';
import useTracking from '@gameday/utils/hooks/useTracking';

import GamedayTrackingEngine from './GamedayTrackingEngine';

const FINAL = 'Final';

const firstPageViewTracking = (Tracking, {
    playIndex,
    gamedayMini
}) => {
    if (typeof playIndex === 'undefined' && !gamedayMini) {
        Tracking.track.track_pageload();
    } if (gamedayMini) {
        Tracking.track.track_gamedayMini_pageload();
    } else {
        Tracking.track.track_atbat_detail_pageload({ playIndex });
    }
};

class MLBGamedayTrackingEngine extends GamedayTrackingEngine {
    constructor (props) {
        super(props);
    }

    trackAsync (props) {
        const defaultMethod = () => console.log('No trackAsync method found.', props);
        const trackAsync = (typeof window !== 'undefined' && window.trackAsync) ? window?.trackAsync : defaultMethod;
        trackAsync(props);
    }

    trackPageView (props) {
        const defaultMethod = () => console.log('No trackPageView method found.', props);
        const trackPageView = (typeof window !== 'undefined' && window.trackPageView) ? window?.trackPageView : defaultMethod;
        trackPageView(props);
    }
};

export default () => {
    const Tracking = useTracking();
    const config = useSelector(getTracking) || {};
    const trackingGameState = useSelector(getTrackingGameState);
    const { gameView, gameTab } = useSelector(getCurrentViewState);
    const { gamePk, batterId, gameState } = trackingGameState;
    const playIndex = useSelector(getPlayIndex);
    const [currentBatterId, setCurrentBatterId] = useState('');
    const gdMini = config?.tracking?.props?.appName?.includes('Gameday Mini');

    // Update trackingGameState every time it changes.
    Tracking.setData({ gameTab, gameView, game: trackingGameState, deviceInteraction: config?.deviceInteraction?.type });

    useEffect(() => {
        const TrackingEngine = new MLBGamedayTrackingEngine(config.tracking);

        TrackingEngine.init();

        if (typeof window !== 'undefined') {
            function handlePageHide (event) {
                if (!event.persisted) {
                    const cfg = {
                        dynamic_component: 'engagement',
                        activity: 'Page Unload',
                        gamedayMini: gdMini
                    };
                    return Tracking.track.track_click(cfg) && false;
                }
            }
            window.addEventListener('pagehide', handlePageHide, false);
            return () => window.removeEventListener('pagehide', handlePageHide);
        }
    }, []);

    // Make a page tracking call ever time we get a new gamePk
    // making sure gamePk is defined as well from the gumbo.
    useEffect(() => {
        if (typeof window !== undefined && gamePk) {
            firstPageViewTracking(Tracking, {
                playIndex,
                gamedayMini: gdMini
            });
        }
    }, [gamePk]);

    useEffect(() => {
        if (currentBatterId === '') {
            if (batterId !== '') {
                setCurrentBatterId(batterId);
            }
        } else {
            if (currentBatterId !== batterId) {
                if (gameState !== FINAL) {
                    Tracking.track.track_new_batter_event();
                }
                setCurrentBatterId(batterId);
            }
        }
    }, [batterId, gameState, currentBatterId]);

    return null;
};
